import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"
import { PaymentPoliciesList } from "../../../../PaymentPolicy"

export default function OrganizationPaymentPoliciesPage() {
	return (
		<>
			<Helmet>
				<title>Payment Policies | Org</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_USERS}>
				<PaymentPoliciesList />
			</ForbidUnlessAuthorized>
		</>
	)
}
